import { useState } from "react";

function IngredientNode({ item, multiplier = 1 }) {
  const totalQuantity = item.quantity * multiplier;

  return (
    <div className="ingredient-node border p-2 rounded-md bg-[var(--panel-sections)] text-[var(--tree-text)] shadow mb-2">
      <div className="flex items-center gap-2">
        <img src={item.image} alt={item.name} className="w-5 h-5" />
        <div>
          <strong>{item.name}</strong>
          <div>× {totalQuantity}</div>
        </div>
      </div>

      {/* If it has sub-ingredients, recurse */}
      {item.ingredients && (
        <div className="ml-4 border-l-2 border-[var(--outline-color)] bg-[var(--panel-sections)] pl-4 mt-2">
          {item.ingredients.map((sub, idx) => (
            <IngredientNode key={idx} item={sub} multiplier={totalQuantity} />
          ))}
        </div>
      )}
    </div>
  );
}

export function CraftMap({ item }) {
  const craftMap = item.craftingMap?.[0]?.allRecipes;
  const [selectedOutput, setSelectedOutput] = useState(1);

  if (!craftMap) {
    return <div className="wiki-crafting text-center py-4">No crafting map to display...</div>;
  }

  const recipe = craftMap.find(r => r.isBestRecipe) || craftMap[0];
  const baseOutput = recipe.outputQuantity;
  const batchesNeeded = Math.ceil(selectedOutput / baseOutput);
  const ingredients = recipe.ingredients;

  return (
    <div className="space-y-4 wiki-production">
      <div className="flex items-center gap-2 justify-between">
        <div className="flex items-center">
        <img src={recipe.image} alt={recipe.name} className="w-12 h-12 inline" />
        <h2 className="text-xl font-semibold">{recipe.name}</h2>
        </div>
        <div className="flex flex-col">
        <span className="text-xs text-[var(--text-color)]">Desired Output</span>
        <input
          type="number"
          className="border px-2 py-1 rounded w-10 right-0 select-forms"
          min={1}
          value={selectedOutput}
          onChange={e => setSelectedOutput(Number(e.target.value))}
        /></div>
      </div>

      <div className="pl-2 mt-1">
        {ingredients.map((ingredient, idx) => (
          <IngredientNode
            key={idx}
            item={ingredient}
            multiplier={batchesNeeded}
          />
        ))}
      </div>
    </div>
  );
}
